module.exports = __webpack_public_path__ + "static/Building-Material-592e529631af77b3042d534b75bf40bf.jpg";